import { Component, Input, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { ContentService } from '../shared/content.service';
import { Content } from '../shared/content';
import { UtilsService } from '../shared/utils.service';
import { ConfigService } from '../shared/config.service';
import { IntlService } from '../shared/intl.service';
import { MetaService } from '../shared/meta.service';

import { isBrowser } from 'angular2-universal';

@Component({
    template: require('./partials/content-writing.html'),
    //styles: [require('../shared/assets/css/footnotes.css')] // does not work
})
export class ContentWritingComponent extends Content {

    constructor(public writingConfig: ConfigService, private writingIntlService: IntlService, private elementRef: ElementRef, public utils: UtilsService, private writingMetaService: MetaService, private writingService: ContentService, private writingRoute: ActivatedRoute) {
        super(writingConfig, writingIntlService, writingMetaService, writingService, writingRoute);
        this.setType('writing');
    }

    // Overrides super class init
    ngOnInit(){
        this.setCurrentLanguage();
        this.setContentAsync();
        this.contentAsync.subscribe(
            (writing: Object) => {
                if(writing!=null) {
                    this.content = writing;
                    this.ready();
                    this.setMeta();
                    // footnotes
                    if (isBrowser) {
                        this.utils.loadScripts(["/resources_shared/assets/js/shared.js"], this.elementRef.nativeElement);
                    }
                } else
                    console.error('Content not set');
            }
        );
    }

    ngAfterContentChecked(){
        super.ngAfterContentChecked();
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/content-writing.component.ts